// extracted by mini-css-extract-plugin
export default {"wrapper":"Z4-z"};